import React from "react"
import momentTZ from "moment-timezone"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {GroupCelebration} from "@irati/types"
import LineThroughText from "./LineThroughText"

interface ScheduledDateProps extends InjectIntl {
  scheduledGroupCelebration: GroupCelebration
}
const ScheduledDate: React.FC<ScheduledDateProps> = ({scheduledGroupCelebration, formatMessage}) => {
  const scheduledDate = momentTZ
    .tz(scheduledGroupCelebration.when, scheduledGroupCelebration.originalTimezone)
    .format("Do, MMMM YYYY, h:mmA")
  const message = formatMessage(
    {id: "platform.recognition.scheduled.date.short.lbl"},
    {
      date: scheduledDate
    }
  )
  return <LineThroughText text={message} />
}

export default injectIntl(ScheduledDate)
